/** @format */

import { SessionAnalysisSearchProps } from './typescript'

/** 会话分析列表默认查询：含全部侧栏筛选项的空初始值 */
export const initSessionAnalysisSearc: SessionAnalysisSearchProps = {
  Page: 1,
  PageSize: 20,
  Filters: []
}
